import clientAPI from "@/api/ClientAPIMixin.js";
import i18n from '@/plugins/i18n.js';

const DeliveryAdressEditModel = {
    headerTitle: i18n.t('servicesystem.common_objects.address.delivery_address'),
    enabledIcon: "mdi-office-building-marker",
    disabledIcon: "mdi-close",
    listItemTextKey: "Name",
    ParentIdKey: "CustomerId",

    fields: [
        { type: "address", valuekey: "DeliveryAddress", editable: true, rules: "noempty", defaultValue: { DisplayName: '', Street: '', Zip: '', City: '', Country: '' } },
    ],

    methods: {
        async save(address) {
            return clientAPI.methods.changeCustomerAdressById(address);
        },
        async create(newaddress) {
            return clientAPI.methods.createCustomerAdress(newaddress);
        },
        async getlist(customerid) {
            return clientAPI.methods.getCustomerAdressesByCustomerId(customerid);
        },
    }
}

export default DeliveryAdressEditModel;